import React, { useState } from 'react';
import { toast } from 'sonner';
import { Download, Send, Loader2, X } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

// Book personnalisé : PDF des slides actuellement diffusées, à télécharger ou à envoyer au client.
export function ClientPdfDialog({ item, slides, onClose }) {
  const { api } = useAuth();
  const [name, setName] = useState(item.titre);
  const [email, setEmail] = useState('');
  const [msg, setMsg] = useState('Bonjour,\n\nSuite à notre rendez-vous, vous trouverez ci-joint notre présentation.\n\nBien cordialement,');
  const [busy, setBusy] = useState('');

  const run = async (mode) => {
    setBusy(mode);
    try {
      if (mode === 'download') {
        const r = await api().post(`/formation/items/${item.id}/pdf-client`, { slides, filename: name }, { responseType: 'blob' });
        const url = URL.createObjectURL(r.data);
        const a = document.createElement('a');
        a.href = url; a.download = `${name || 'presentation'}.pdf`; a.click();
        URL.revokeObjectURL(url);
        toast.success('PDF téléchargé');
      } else {
        await api().post(`/formation/items/${item.id}/pdf-client`, { slides, filename: name, email_to: email, message: msg });
        toast.success(`PDF envoyé à ${email}`);
        onClose();
      }
    } catch (e) {
      const d = e?.response?.data;
      const txt = d instanceof Blob ? JSON.parse(await d.text()).detail : d?.detail;
      toast.error(txt || 'Opération impossible');
    } finally { setBusy(''); }
  };
  const field = 'w-full rounded-md bg-white/10 border border-white/15 text-white text-sm px-3 py-2 placeholder:text-white/40 focus:outline-none focus:border-orange';

  return (
    <div className="absolute inset-0 z-30 bg-black/70 flex items-center justify-center p-4" onClick={onClose}>
      <div className="w-full max-w-md rounded-xl bg-[#1b1c1f] border border-white/10 p-5 space-y-3" onClick={e => e.stopPropagation()} data-testid="client-pdf-dialog">
        <div className="flex items-center">
          <p className="flex-1 text-white font-semibold">Book personnalisé client</p>
          <button onClick={onClose} className="text-white/60 hover:text-white" data-testid="client-pdf-close"><X className="w-5 h-5" /></button>
        </div>
        <p className="text-xs text-white/60" data-testid="client-pdf-count">{slides.length} slide(s) incluse(s) — celles affichées dans votre diffusion. Masquez des slides pour ajuster.</p>
        <input className={field} value={name} onChange={e => setName(e.target.value)} placeholder="Nom du fichier" data-testid="client-pdf-name" />
        <div className="flex">
          <button onClick={() => run('download')} disabled={!!busy || !slides.length} data-testid="client-pdf-download"
            className="h-10 px-4 rounded-md bg-white/10 hover:bg-white/20 text-white text-sm font-semibold inline-flex items-center gap-2 disabled:opacity-40">
            {busy === 'download' ? <Loader2 className="w-4 h-4 animate-spin" /> : <Download className="w-4 h-4" />} Télécharger le PDF
          </button>
        </div>
        <div className="border-t border-white/10 pt-3 space-y-2">
          <p className="text-xs font-semibold uppercase tracking-wide text-white/50">Ou envoyer au client</p>
          <input className={field} type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="email@client.fr" data-testid="client-pdf-email" />
          <textarea className={field} rows={4} value={msg} onChange={e => setMsg(e.target.value)} data-testid="client-pdf-message" />
          <p className="text-[11px] text-white/40">Vous êtes mis en copie de l'email.</p>
          <button onClick={() => run('email')} disabled={!!busy || !slides.length || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)} data-testid="client-pdf-send"
            className="h-10 px-4 rounded-md bg-orange text-orange-on text-sm font-semibold inline-flex items-center gap-2 disabled:opacity-40">
            {busy === 'email' ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />} Envoyer au client
          </button>
        </div>
      </div>
    </div>
  );
}
